import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createBlock as _createBlock, createVNode as _createVNode, createElementVNode as _createElementVNode } from "vue"

const _hoisted_1 = { key: 0 }
const _hoisted_2 = {
  key: 0,
  class: "text-h6 q-pa-md"
}

import { PropType, computed } from "vue";
    import { Vehicle } from "src/types/loan-application/index";
    import  { useCurrencyFormatter } from 'src/functions';
    import DataTable from "src/components/form/forms/DataTable.vue";
    
    
export default /*@__PURE__*/_defineComponent({
  __name: 'GlassValuationsForm',
  props: {
      modelValue: {
        type: Object as PropType<Vehicle>,
        default: {} as Vehicle
      },
      showTitle: {
        type: Boolean,
        default: true
      },
    },
  emits: [
      'update:modelValue'
    ],
  setup(__props, { emit: __emit }) {

    const props = __props
  
  
    const value = computed<Vehicle>({
      get() {
        return props.modelValue
      },
      set(value: Vehicle) {
        emit('update:modelValue', value)
      }
    })
  
    const emit = __emit
  
    const glassesValuation = computed(() => {
      return [
        { label: "Effective From", value: value.value.glassesEffectiveFrom ? new Date(value.value.glassesEffectiveFrom).toLocaleDateString() + " @ " + (value.value.mileage ? value.value.mileage.toLocaleString() + ' miles' : 'Mileage Unknown'): "-" },
        { label: "Glasses Retail Transacted", value: value.value.glassesRetailTransacted ? useCurrencyFormatter(value.value.glassesRetailTransacted, 2, 2) : "-" },
        { label: "Glasses Retail Valuation", value: value.value.glassesRetailValuation ? useCurrencyFormatter(value.value.glassesRetailValuation, 2, 2) : "-" },
        { label: "Glasses Trade Valuation", value: value.value.glassesTradeValuation ? useCurrencyFormatter(value.value.glassesTradeValuation, 2, 2) : "-" }
      ]
    })
  
return (_ctx: any,_cache: any) => {
  const _component_q_separator = _resolveComponent("q-separator")!

  return (glassesValuation.value != null)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        (__props.showTitle)
          ? (_openBlock(), _createElementBlock("div", _hoisted_2, " Glasses Valuation "))
          : _createCommentVNode("", true),
        (__props.showTitle)
          ? (_openBlock(), _createBlock(_component_q_separator, {
              key: 1,
              style: {"border-width":"3px !important"}
            }))
          : _createCommentVNode("", true),
        _createElementVNode("div", null, [
          _createVNode(DataTable, { data: glassesValuation.value }, null, 8, ["data"])
        ])
      ]))
    : _createCommentVNode("", true)
}
}

})